import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';

import { LoadingComponent } from '../loading/loading.component';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoadingComponent],
})
export class AuthCallbackComponent implements OnInit {
  private router = inject(Router);

  ngOnInit() {
    // A spinner while the SDK finishes the exchange and navigates to
    // appState.target. The same params the SDK treats as a callback in
    // flight; without them nothing is going to navigate, so leave.
    const params = new URLSearchParams(window.location.search);
    const inFlight = (params.has('code') || params.has('error')) && params.has('state');

    if (!inFlight) {
      this.router.navigateByUrl('/');
    }
  }
}
